import React, { useState, useEffect } from "react";
import {
  Box, 
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import firebase from "../utils/firebaseConfig"
import { fetchData } from "../actions";
import { deleteItem } from "../actions";

import NanoCompVisualiser from "../components/NanoCompVisualiser"

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import FolderIcon from '@mui/icons-material/Folder';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';


const MyStudies = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataMaster, setDataMaster] = useState([]);
  const [data, setData] = useState([]);
  const dataFilter = [];
  const localStore = useSelector(state => state.nanoCompDataReducer);
  const auth = useSelector(state => state.firebase);
  const dispatch = useDispatch();

useEffect(() => {
  setIsLoading(true);
  async function getdata() {
    const ref = firebase
        .firestore()
        .collection("myStudies");
      const snapshot = await ref.get();
      const fetchedData = []
      const sortedData = []
      snapshot.forEach(doc => {
        fetchedData.push(doc.data());
      });
    fetchedData.sort((a, b) => (a.index > b.index) ? 1 : -1)

      fetchedData.map((d,i) => {
        if(d.author == auth.auth.uid) {
          sortedData.push(d)
        }
      })
      setDataMaster(fetchedData)
      setData(sortedData)
    }
    getdata()
    setTimeout(() => {
      setIsLoading(false);

    }, 1000)
},[localStore])

  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState([]);
  const [storageData, setStorageData] = useState([]);
  const [comp, setComp] = useState(0);
  const [secondary, setSecondary] = useState(false);

  const [destination, setDestination] = useState("");

  const pages = [
    {name: destination, address: "/nanocontent"},
    // {name: "nanocontent", address:`destination`},
  ];

return (
  <div>
    {isLoading == true ? (

      <CircularProgress style={{ display: "flex", position: "absolute", top: "50%", left: "50%", marginRight: "-50%", transform: "translate(-50%, -50%)" }} />

    ) : (

    <>
      <h1 className="pageHeader1">My NanoCompetencies</h1>
    
      {data.length > 1 ? (
        
        <div>
          <Box textAlign="center">
            <h3>You currently have no NanoCompetencies</h3>
            <h3>Please proceed by signing up to content</h3>
          </Box>
        </div>

      ) : (
        
        <div>
          <Box textAlign="center">
            <h3>{data.length} NanoCompetencies found</h3>
          </Box>
            <List style={{ margin: "5vw 5vw 0 5vw" }}>
           
              {data.map((d, i) => (
                <>
                  <ListItem
                    key={i}
                    onClick={() => setDestination(d.name.replace(/ /g,"_"))}
                    secondaryAction={
                    <>
                      <IconButton edge="end" aria-label="delete" onClick={() => dispatch(deleteItem(d))}>
                        <DeleteIcon />
                      </IconButton>
                    </>}
                  >
                    <>
                      <Link 
                        to={pages[0].address} 
                        state={d}
                        style={{ textDecoration: "none", color: "#000", width: "100%" }}
                        key={i}
                      >
                  
                        <ListItemText
                          primary={d.name}
                          secondary={d.description.length > 90 ? (
                          d.description.slice(0, 90) + "..." ) : (d.description)}
                        />
                      </Link>
                    </>
                  </ListItem>
                </>
              ))}
            </List>
        </div>
      )}
    </>
    )}
  </div>
  );
};


export default MyStudies;